
jQuery(function() {



/**
 * topページでスライド実行(スマフォ)
 */
{

	let slid = new sd_slideshow(7500);

	jQuery(window).on('load',function(){

		if(jQuery('body').hasClass('home')){

			//スライドショウ実行
			slid.slideshow();

			//スライド高さセット実行
		 	slid.heightSet();

		}

	 });

	/**
	 * スライドショウ高さ再セット実行
	 */
	jQuery(window).on('resize',function(){


		if(jQuery('body').hasClass('home')){

			//timerID;
			var timer = false;

			if (timer !== false) {
				clearTimeout(timer);
			}

			timer = setTimeout(function() {
				slid.heightSet();
			}, 1000);

		}

	 });

};



/**
 * フルスクリーンナビゲーション
 */
(function(){

	var gNav     = new fullScreenNavigation();
	var $navBtn  = jQuery('#nav_btn');
	var $nav     = jQuery('.footer-nav');
	var $navBody = jQuery('.footer-nav__body,.menu > ul');

	jQuery($navBtn).on('click',function(){
		if($nav.hasClass('sd-fade-in')){
			gNav._openNavgation($navBtn,$nav,$navBody);
		} else {
			gNav._closeNavgation($navBtn,$nav,$navBody);
		}
	});

	//ウィンドウをリサイズすると、ナビゲーションとスクロールを初期設定に戻す。
	jQuery(window).on('resize',function(){
		gNav._navgationInitialize($navBtn,$nav,$navBody);
	});

}());



/**
 * スライド実行
 */
(function(){

	gVar.slid = new sd_slideshow(7500);

	jQuery(window).on('load',function(){

		//スライドショウ実行
		gVar.slid.slideshow();

		//スライド高さセット実行
	 	gVar.slid.heightSet();

	 });

	/**
	 * スライドショウ高さ再セット実行
	 */
	jQuery(window).on('resize',function(){

		//timerID;
		var timer = false;

		if (timer !== false) {
			clearTimeout(timer);
		}

		timer = setTimeout(function() {
		 	gVar.slid.heightSet();
		}, 1000);

	 });

}());





/**
 * 可視領域に要素が出現した時にanimate.cssのclassを付与し、スクロールに対するインタラクションを実行させる。
 */
jQuery(window).on('touchstart scroll', function(){
	fadeIn('.go-to-top');
});

jQuery(window).on('load touchstart scroll', function(){
	animateScroll();
});


/**
 * ウィンドウ上部に戻る
 */
jQuery('.go-to-top').on('click',function(){
	jQuery('body, html').animate({ scrollTop: 0 }, 800, 'swing');
	return false;
});



/**
 * ページ内スムーズスクロール実行(a要素を指定する)
 */
smoothScroll('a[href^=#]');



/**
 * slick topページ スライド
 */
jQuery('.home .multiple-items').slick({
	infinite: true,
//		slidesToShow: 3,
	autoplay: true, //自動でスライドさせる
	slidesToScroll: 1, // 一枚ずつスライドさせる
	variableWidth: true, //falseでスライド画像を可変させる
	centerMode: true, //スライドをセンターに設定す
	appendArrows: jQuery('#arrow') //スライド作動ボタンを任意の要素の中に出力
});



/**
 * slick 年間行事 スライド
 */
jQuery(window).on('load', function(){

	if(jQuery('body').hasClass('event')){

		jQuery('.one-time').slick({

			//初期設定
			speed: 400,
			infinite: true,
			// variableWidth: true, //trueでスライド画像を可変を止める

			//レイアウトの設定
			//centerMode: false, //スライドをセンターに設定

			//オートプレイ実行時の設定
			autoplay: true, //自動でスライドさせる
			autoplaySpeed: 8000,
			slidesToShow: 1,
			// slidesToScroll: 1, // 一枚ずつスライドさせる

			//コントローラーの設定
			arrows: true,
			//dots: true, //スライド下部のドットの表示設定
			//appendArrows: jQuery('#arrow'), //スライド作動ボタンを任意の要素の中に出力
			prevArrow: '<button type="button" class="sd-btn slick-prev arrow-l zoom"></button>',
			nextArrow: '<button type="button" class="sd-btn slick-next arrow-r zoom"></button>',

			//その他
			fade: true,
			adaptiveHeight: true,

		});

	}

});




});//jQuery end